export default __webpack_public_path__ + "3c10a35fbc97c8f9e80f25f1c28c5448.png";